import { isIOS } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { createPropGetter, getThemeFontSize } from 'utilities';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  background: ${({ isMobile }) => (isMobile ? '#fff' : 'transparent')};
  min-height: 100vh;

  ${({ isSdk }) =>
    isSdk &&
    css`
      padding-top: 0;
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: auto;
      margin: unset;
      padding: unset;
      background: none;
    `}

${({ isSdk, isMobile }) =>
    isSdk &&
    !isMobile &&
    css`
      margin-top: unset;
      border-radius: unset;
      width: unset;
      min-width: 500px;
    `}

${({ isSdk, isMobile }) =>
    isSdk &&
    isMobile &&
    css`
      width: 100%;
      min-width: unset;
      padding: 0 12px;
      box-sizing: border-box;
    `}
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
  margin: 0 auto;

  ${({ isMobile, isSdk }) =>
    isMobile &&
    !isSdk &&
    css`
      & > div {
        margin-top: 48px;
      }
    `}
`;

export const FooterWrapper = styled.div`
  flex-shrink: 0;

  ${({ isSdk, isMobile }) =>
    isSdk &&
    !isMobile &&
    css`
      width: 100vw;
    `}

  ${({ isSdk, isMobile }) =>
    isSdk &&
    isMobile &&
    css`
      width: 100vw;
      max-width: 400px;
    `}
`;
export const inputProp = createPropGetter('input');

export const Label = styled.div`
  font-size: ${getThemeFontSize('small')};
  font-weight: 500;
  font-family: ${inputProp('base.fontFamily')};
  color: ${inputProp('base.color')};
  flex: 1;

  ${({ required }) => {
    return (
      required &&
      css`
        &:after {
          content: ' *';
          color: ${inputProp('error.labelColor')};
        }
      `
    );
  }}

  ${({ isSdk, isActive, value }) =>
    !isSdk &&
    css`
      position: absolute;
      bottom: 5px;
      margin-bottom: 0;
      pointer-events: none;
      z-index: 10;
      transform: translate3d(0, 0, 0);
      transition: ${isIOS ? '' : '0.3s, opacity 0s'};

      ${(isActive || isValidValue(value)) &&
      css`
        bottom: 110%;
        font-size: ${getThemeFontSize('extraSmall')};
        font-weight: 500;
      `}
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${inputProp('active.labelColor')};
    `}

  ${({ isError }) =>
    isError &&
    css`
      color: ${inputProp('error.labelColor')};
    `}

  ${({ value, isActive, isSdk }) =>
    !isSdk &&
    !isActive &&
    !isValidValue(value) &&
    css`
      color: ${inputProp('placeholder.color')};
    `}
`;

export const isValidValue = value => {
  return value || value === 0 || value === '0';
};
